import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="uAdQv-fK188"
                    title="INSTAR Kamera Tool: Neue Version 2.2.0 für Windows und 2.4 für MacOS mit neuer Update-Funktion"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="INSTAR Kamera Tool: Neue Version 2.2.0 für Windows und 2.4 für MacOS mit neuer Update-Funktion"
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
